module.exports = __webpack_public_path__ + "img/image 12 (1).df15eadc.png";